import { cdnCommonPath } from "@/constants/cdnUrls";
import { useTranslationDetector } from "@/hooks/useTranslationDetector";
import { Link } from "@/i18n/navigation";
import { byPrefixAndName } from "@awesome.me/kit-12cf79935c/icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import Image from "next/image";
import { IconApple, IconGooglePlay } from "../ui/Icon";
import NewsletterForm from "./NewsletterForm";

export default function FooterMiddle() {
  const t = useTranslationDetector();

  return (
    <section>
      <div className="container">
        <div className="flex flex-col justify-between gap-4 md:flex-row md:gap-6">
          <div className="bg-background-global flex flex-col gap-6 rounded-lg p-6 md:w-1/2 md:px-8">
            <div className="flex flex-col gap-6 md:gap-3">
              <div className="flex flex-col gap-2">
                <h6 className="m-0 text-lg font-semibold">
                  {t("footer.easytotravel")}
                </h6>
                <p className="text-foreground-muted">
                  {t("footer.easytotraveldescription")}
                </p>
              </div>
              <div className="border-primary-weak flex items-start justify-between gap-6 rounded-2xl border bg-white p-6">
                <div className="flex flex-col gap-2">
                  <h6 className="text-3xl font-semibold">
                    {t("footer.downloadcount")}
                  </h6>
                  <p className="text-sm">
                    {t("footer.downloadcountdescription")}
                  </p>
                </div>
                <div className="flex flex-col gap-2">
                  <div className="asfd">
                    <span className="text-3xl font-semibold">
                      {t("footer.rating")}
                    </span>
                    <span className="text-gray-400">/5</span>
                  </div>
                  <p className="text-sm">{t("footer.ratingdescription")}</p>
                </div>
                <Image
                  className="hidden lg:block"
                  src={cdnCommonPath + "/app-download-qr.png"}
                  width={76}
                  height={76}
                  alt="app-store"
                />
              </div>
            </div>
            <div className="flex flex-col items-center justify-center gap-3 lg:flex-row">
              <Link
                href="https://turna.go.link?adj_t=1ysjewub&adj_engagement_type=fallback_click"
                target="_blank"
                className="flex w-full items-center justify-center gap-2 rounded-lg bg-black px-4 py-3 font-semibold text-white"
              >
                <IconGooglePlay />
                <span>{t("footer.googleplay")}</span>
              </Link>
              <Link
                href="https://turna.go.link?adj_t=1ysjewub&adj_engagement_type=fallback_click"
                target="_blank"
                className="flex w-full items-center justify-center gap-2 rounded-lg bg-black px-4 py-3 font-semibold text-white"
              >
                <IconApple />
                <span> {t("footer.applestore")}</span>
              </Link>
            </div>
          </div>
          <div className="flex flex-col gap-6 lg:w-1/2">
            <div className="border-primary-weak flex flex-col items-start gap-2 rounded-lg border bg-white p-6 md:flex-row md:gap-8 md:p-8">
              <div>
                <FontAwesomeIcon
                  icon={byPrefixAndName.fal["comments"]}
                  className="text-primary text-4xl"
                />
              </div>
              <div className="flex flex-col gap-2">
                <h6 className="text-lg font-semibold">
                  {t("footer.liveticketsupport")}
                </h6>
                <p
                  className="text-foreground-muted"
                  dangerouslySetInnerHTML={{
                    __html: t.raw("footer.liveticketsupportdescription"),
                  }}
                />
              </div>
            </div>
            <div className="border-primary-weak flex flex-col items-start gap-2 rounded-lg border bg-white p-6 md:flex-row md:gap-8 md:p-8">
              <div>
                <FontAwesomeIcon
                  icon={byPrefixAndName.fak["paper-plane-with-tail"]}
                  className="text-primary text-4xl"
                />
              </div>
              <div className="flex w-full flex-col gap-2">
                <h6 className="text-lg font-semibold">
                  {t("footer.newsletter")}
                </h6>
                <p className="text-foreground-muted">
                  {t("footer.newsletterdescription")}
                </p>
                <NewsletterForm />
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
